import 'react-sizes';
import '../utilities/withSizes.js';
import { useTheme } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/omit.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, useEffect, useRef, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../Spinner/Spinner.js';
import '../utils-fabc7ae7.js';
import 'react-dom';
import 'react-spring/renderprops.cjs';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../Checkbox/CheckboxBase.js';
import '../Checkbox/CheckboxCircle.js';
import '../Checkbox/utils.js';
import '../Checkbox/Checkbox.js';
import 'element-resize-detector';
import '../ContainerDimensions/ContainerDimensions.js';
import '../Pagination/Pager.js';
import '../Pagination/Pagination.js';
import './BaseTable.js';
import 'rc-table';
import '../Td-2423cb3a.js';
import './createBodyRow.js';
import './createHeaderCell.js';
import { Column } from './TableVirtualizedInfiniteColumn.js';
import TableLoader from './TableLoader.js';
import 'react-resizable';
import './createBodyCell.js';
import { getCurrentBreakpoint } from './utils/index.js';
import './Column.js';
import './SelectionBox.js';
import './SelectionCheckboxAll.js';
import { getRowKey } from './utils/get-row-key.js';
import './createStore.js';
import Table from './Table.js';
import { VariableSizeGrid } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import './utils/get-is-equal.js';
import { getColumnsWithWidths } from './utils/get-columns-with-widths.js';

const _excluded = ["rowAs", "rowPropsGetter", "getExpandedRowHeight", "getRowHeight", "estimatedRowHeight", "expandedRowRender", "totalCount", "loading", "columns", "scroll", "hasNextPage", "isNextPageLoading", "minimumBatchSize", "scrollTo", "emptyPlaceholder", "onScroll", "onLoadNextPage", "overscanRowCount", "rowSelection", "dataSource", "rowKey"];
const SELECTION_WIDTH = 40;
function TableVirtualizedInfinite(_ref) {
  var _gridRef$current3, _gridRef$current3$_li;
  let {
      rowAs = 'div',
      rowPropsGetter = null,
      getExpandedRowHeight = () => 200,
      getRowHeight = () => 42,
      estimatedRowHeight = 42,
      expandedRowRender = null,
      totalCount,
      loading,
      columns,
      scroll,
      hasNextPage,
      isNextPageLoading,
      minimumBatchSize,
      scrollTo = null,
      emptyPlaceholder,
      onScroll,
      onLoadNextPage,
      overscanRowCount = 15,
      rowSelection,
      dataSource,
      rowKey
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const [tableWidth, setTableWidth] = useState(0);
  const [tableStore, setTableStore] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  useEffect(() => {
    let unsubscibe = null;
    if (tableStore) {
      unsubscibe = tableStore.subscribe(() => {
        const {
          selectedRowKeys
        } = tableStore.getState();
        (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.onChange) && (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.onChange(selectedRowKeys, null));
      });
      const defaultCheckedKeys = dataSource.filter(record => {
        if (!rowSelection) {
          return false;
        }
        const {
          defaultChecked
        } = rowSelection.getCheckboxProps(record);
        return defaultChecked;
      }).map((record, index) => getRowKey(record, index, rowKey));
      const currentState = tableStore.getState();
      tableStore.setState(_objectSpread2(_objectSpread2({}, currentState), {}, {
        selectedRowKeys: defaultCheckedKeys
      }));
    }
    return () => unsubscibe && unsubscibe();
  }, [tableStore]);
  useEffect(() => {
    setTableWidth(scroll.x);
  }, [scroll.x]);
  const isItemLoaded = index => {
    return !hasNextPage || index < dataSource.length;
  };
  const loadMoreItems = isNextPageLoading ? () => Promise.resolve() : onLoadNextPage;
  const allColumns = rowSelection ? [{
    dataIndex: 'selection-column',
    key: 'selection-column',
    width: SELECTION_WIDTH
  }, ...columns] : columns;
  const currentBreakpoint = getCurrentBreakpoint(tableWidth, theme);
  const tableWithoutScrollbarWidth = tableWidth - scrollbarWidth;
  const mergedColumns = getColumnsWithWidths(allColumns.filter(({
    columnBreakpoints
  }) => columnBreakpoints && columnBreakpoints.length ? columnBreakpoints.indexOf(currentBreakpoint) !== -1 : true), tableWithoutScrollbarWidth);
  const gridRef = useRef();
  const [connectObject] = useState(() => {
    const obj = {};
    Object.defineProperty(obj, 'scrollLeft', {
      get: () => null,
      set: scrollLeft => {
        if (gridRef.current && gridRef.current._listRef) {
          gridRef.current._listRef.scrollTo({
            scrollLeft
          });
        }
      }
    });
    return obj;
  });
  const resetVirtualGrid = () => {
    if (gridRef.current && gridRef.current._listRef) {
      gridRef.current._listRef.resetAfterIndices({
        columnIndex: 0,
        shouldForceUpdate: false
      });
      gridRef.current._listRef.resetAfterRowIndex(0);
    }
  };
  useEffect(() => resetVirtualGrid, [tableWidth, columns, dataSource]);
  useEffect(() => {
    if (scrollTo) {
      var _gridRef$current, _gridRef$current$_lis, _gridRef$current$_lis2;
      const {
        x,
        y
      } = scrollTo;
      (_gridRef$current = gridRef.current) === null || _gridRef$current === void 0 ? void 0 : (_gridRef$current$_lis = _gridRef$current._listRef) === null || _gridRef$current$_lis === void 0 ? void 0 : (_gridRef$current$_lis2 = _gridRef$current$_lis._outerRef) === null || _gridRef$current$_lis2 === void 0 ? void 0 : _gridRef$current$_lis2.scrollTo(x, y);
    }
  }, [scrollTo]);
  useEffect(() => {
    var _gridRef$current2, _gridRef$current2$_li;
    const {
      offsetWidth,
      clientWidth
    } = (gridRef === null || gridRef === void 0 ? void 0 : (_gridRef$current2 = gridRef.current) === null || _gridRef$current2 === void 0 ? void 0 : (_gridRef$current2$_li = _gridRef$current2._listRef) === null || _gridRef$current2$_li === void 0 ? void 0 : _gridRef$current2$_li._outerRef) || {};
    const currentScrollbarWidth = offsetWidth - clientWidth;
    if (!Number.isNaN(currentScrollbarWidth)) {
      setScrollbarWidth(currentScrollbarWidth);
    }
  }, [gridRef === null || gridRef === void 0 ? void 0 : (_gridRef$current3 = gridRef.current) === null || _gridRef$current3 === void 0 ? void 0 : (_gridRef$current3$_li = _gridRef$current3._listRef) === null || _gridRef$current3$_li === void 0 ? void 0 : _gridRef$current3$_li._outerRef, dataSource]);
  const renderVirtualList = (rawData, {
    scrollbarSize,
    ref,
    onScroll: onVirtualListScroll,
    onItemsRendered
  }) => {
    ref.current = connectObject;
    const height = scroll.y;
    if (loading) {
      return /*#__PURE__*/createElement(TableLoader, {
        height: height
      });
    }
    if (totalCount === 0) {
      return /*#__PURE__*/createElement("div", {
        style: {
          height
        }
      }, emptyPlaceholder);
    }
    return /*#__PURE__*/createElement(VariableSizeGrid, {
      overscanRowCount: overscanRowCount,
      ref: ref,
      columnCount: mergedColumns.length,
      columnWidth: index => {
        const {
          width
        } = mergedColumns[index];
        return index === mergedColumns.length - 1 ? typeof width === 'number' ? width - scrollbarSize - 1 : parseFloat(width) - scrollbarSize - 1 : width;
      },
      height: height,
      rowCount: totalCount,
      rowHeight: rowIndex => expandedRows.includes(rowIndex) ? getExpandedRowHeight(rowIndex, rawData[rowIndex]) : getRowHeight(rowIndex),
      estimatedRowHeight: estimatedRowHeight,
      width: tableWidth,
      itemData: {
        mergedColumns,
        rawData,
        rowAs,
        rowPropsGetter,
        setExpandedRows,
        expandedRows,
        resetVirtualGrid,
        gridRef,
        expandedRowRender,
        getExpandedRowHeight,
        getRowHeight,
        tableStore,
        rowKey,
        rowSelection
      },
      onItemsRendered: ({
        visibleRowStartIndex: visibleStartIndex,
        visibleRowStopIndex: visibleStopIndex
      }) => onItemsRendered({
        visibleStartIndex,
        visibleStopIndex
      }),
      onScroll: tableScroll => {
        onScroll && onScroll(tableScroll);
        onVirtualListScroll({
          scrollLeft: tableScroll === null || tableScroll === void 0 ? void 0 : tableScroll.scrollLeft
        });
      }
    }, Column);
  };
  return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(InfiniteLoader, {
    ref: gridRef,
    itemCount: totalCount,
    minimumBatchSize: minimumBatchSize,
    isItemLoaded: isItemLoaded,
    loadMoreItems: loadMoreItems,
    threshold: minimumBatchSize
  }, ({
    onItemsRendered,
    ref
  }) => /*#__PURE__*/createElement(Table, _extends({}, props, {
    onStoreCreated: store => setTableStore(store),
    rowKey: rowKey,
    dataSource: dataSource,
    rowSelection: rowSelection ? _objectSpread2({
      columnWidth: SELECTION_WIDTH
    }, rowSelection) : rowSelection,
    onChange: (pagination, filter, sorter) => {
      props.onChange(pagination, filter, sorter);
      setExpandedRows([]);
      resetVirtualGrid();
    },
    scroll: {
      y: scroll.y
    },
    columns: mergedColumns,
    pagination: false,
    components: {
      body: (rawData, options) => renderVirtualList(rawData, _objectSpread2(_objectSpread2({}, options), {}, {
        ref,
        onItemsRendered
      }))
    }
  }))));
}

export default TableVirtualizedInfinite;
